import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/data.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-searchprofilelayout",
  templateUrl: "./searchprofilelayout.component.html",
  styleUrls: ["./searchprofilelayout.component.scss"],
})
export class SearchprofilelayoutComponent implements OnInit {
  profiles: any[];
  metasearchlayout: {
    metaobjectid: any;
    filter: (arg0: (layout: any) => boolean) => any;
  };
  isLoading = false;
  isError = false;
  errorMessage = "";
  objectId: any;
  objectName: any;
  filteredLayouts: any[];
  profileId: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.objectName = this.route.snapshot.params.label;
      this.objectId = this.route.snapshot.params.objectid;
    });

    this.getActiveProfiles().then((res) => {
      console.log("response111111", res);

      this.getSearchLayout();
    });

    // this.getSearchLayout();
    // this.getActiveProfiles();
    // this.getSearchLayout();
  }

  displayedColumns: string[] = ["action", "profile", "field"];
  dataSource: any;

  getActiveProfiles() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense"),
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profiles = res.data.profiles;
            var profileArray = [];
            //just add an empty entry sice this field is optional
            for (let i = 0; i < this.profiles.length; i++) {
              console.log(this.profiles);
              profileArray.push({
                profileid: this.profiles[i].id,
                profilename: this.profiles[i].name,
              });
            }
            if (this.profiles != null) {
              this.dataSource = this.profiles.map(
                (item: { name: any; id: any }) => ({
                  profile: item.name,
                  profileid: item.id,
                  iseditDisabled: true,

                  // field: item.field
                })
              );
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No profile data!");
            this.errorMessage = res != null ? res.message : "No profile data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getSearchLayout() {
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metasearchlayout: {
          metaobjectid: this.objectId,
          // profileid: this.profileId,
          profileid: userDetail.profileid,
        },
      },
    };

    console.log(postOption);
    this.isLoading = true;
    this.dataService.getAllSearchLayout(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metasearchlayout = res.data.metasearchlayout;
          // console.log("Doneeee****", this.metasearchlayout.metaobjectid);
          console.log("Doneeee****", this.metasearchlayout);

          this.filteredLayouts = this.metasearchlayout.filter(
            (layout: { metaobjectid: any }) =>
              layout.metaobjectid === this.objectId
          );
          //  alert("success")
          console.log(this.filteredLayouts);

          // Combine profiles and filtered layouts
          this.dataSource = this.profiles.map((profile) => {
            // Find the corresponding layout for the profile
            const layout = this.filteredLayouts.find(
              (layout: { profileid: any }) => layout.profileid === profile.id
            );
            return {
              id: layout ? layout.id : "", // Include the layout id if available
              profile: profile.name,
              profileid: profile.id,
              field: layout ? layout.fieldsdisplayed : "No layout",
              isnewDisabled: layout ? true : false, // Adjust based on your needs
              iseditDisabled: !layout, // Set to true if no layout is found
            };
          });

          // const isnewDisabled = this.filteredLayouts.length > 0;
          // console.log(isnewDisabled);

          // if (this.filteredLayouts != null && this.filteredLayouts.length > 0) {
          //   this.dataSource = this.filteredLayouts.map((item) => ({
          //     id: item.id,
          //     profile: item.profilename,
          //     profileid: item.profileid,
          //     field: item.fieldsdisplayed,
          //     isnewDisabled: true,
          //   }));
          // }

          console.log(this.dataSource);

          this.isLoading = false;
        } else {
          console.log("no searchlayout data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }
}
